export enum SceneKeys {
  PreloadScene = 'PreloadScene',
  MainScene = 'MainScene',
}
